import Image from "next/image";
import { Competency, isCompetency, LearnerOutcome } from "@/lib/models";

type OverviewHexagonProps = {
  entity: LearnerOutcome | Competency;
  selectedEntity: Competency | LearnerOutcome | null;
  handleHexagonClick: (entity: Competency | LearnerOutcome) => void;
  searchResultIds: string[];
};

export const OverviewHexagon = ({
  entity,
  selectedEntity,
  handleHexagonClick,
  searchResultIds,
}: OverviewHexagonProps) => {
  const isSearchApplied = searchResultIds?.length > 0;
  const isInSearchResults = searchResultIds?.includes(entity.id);
  const isAnythingSelected = !!selectedEntity;
  const isSelectedEntity = selectedEntity?.id === entity.id;

  let opacity = "opacity-100";

  if (
    isAnythingSelected &&
    !isSelectedEntity &&
    (!isSearchApplied || isInSearchResults)
  ) {
    opacity = "opacity-60";
  }

  if (isSearchApplied && !isInSearchResults && !isSelectedEntity) {
    opacity = "opacity-20";
  }

  const selectionStyles = () => {
    if (!isAnythingSelected) return "";

    return isSelectedEntity
      ? "z-30 scale-[1.08] drop-shadow-[0_8px_8px_rgba(0,0,0,0.3)]"
      : "";
  };

  if (isCompetency(entity)) {
    return (
      <button
        aria-label={entity.name}
        className="relative mx-[1px] flex h-[138px] w-[120px]"
        onClick={() => handleHexagonClick(entity)}
      >
        <Image
          src={entity.namedIcon.sourceUrl!}
          width={120}
          height={138}
          alt={entity.name}
          className={`absolute max-w-max transition duration-200 hover:z-20 hover:scale-[1.08] hover:opacity-100 hover:drop-shadow-[0_16px_16px_rgba(0,0,0,0.30)] ${selectionStyles()} ${opacity}`}
        />
      </button>
    );
  } else {
    return (
      <button
        aria-label={entity.name}
        className="relative mx-[1px] flex h-[138px] w-[120px]"
        onClick={() => handleHexagonClick(entity)}
      >
        <Image
          src={entity.learnerOutcomeCard.sourceUrl!}
          width={120}
          height={138}
          alt={entity.name}
          className={`absolute max-w-max transition duration-200 hover:z-20 hover:scale-[1.08] hover:opacity-100 hover:drop-shadow-[0_16px_16px_rgba(0,0,0,0.30)] ${selectionStyles()} ${opacity}`}
        />
      </button>
    );
  }
};
